import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { breakpoints } from '@99designs/emu/settings';
import { CarouselItems } from './CarouselItems';
import { CarouselSteps } from './CarouselSteps';
import { useAutoScroll } from './useAutoScroll';

export interface CarouselContainerProps {
    items: React.ReactNode[];
    height?: string | Record<breakpoints.ScreenSize, string>;
    stopScrollOnClick?: boolean;
    interval?: number;
}

const Container = styled(Box)`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export function CarouselContainer({
    items,
    height,
    stopScrollOnClick,
    interval,
}: CarouselContainerProps) {
    const [currentIndex, setCurrentIndex] = useAutoScroll(
        items.length,
        stopScrollOnClick,
        interval
    );

    return (
        <Container>
            <CarouselItems
                items={items}
                currentItemIndex={currentIndex}
                onSwipe={setCurrentIndex}
                height={height}
            />
            <CarouselSteps
                count={items.length}
                currentIndex={currentIndex}
                onClick={setCurrentIndex}
            />
        </Container>
    );
}
